import React, { useState, useEffect } from 'react'

import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { actionDetailTransaction } from '../../store/actions/transaction'
import { formatPrice } from '../../helpers'
import { FormReview, StatusBadge } from './components'

const HistoryDetail = ({
  match,
  history,
  detailTransaction,
  dispatchDetailTransaction
}) => {
  const codeParam = match?.params?.code || match?.params?.id

  const [reviews, setReviews] = useState({})
  const [showReviewModal, setShowReviewModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  useEffect(() => {
    if (codeParam) {
      dispatchDetailTransaction(codeParam)
    }
  }, [dispatchDetailTransaction, codeParam])

  const handlePageHome = () => {
    history.push('/')
  }

  const handlePageHistory = () => {
    history.push('/transaksi')
  }

  const handleSaveReview = (newReview, item) => {
    const itemId = item?.id || item?.product_id
    setReviews(prev => ({
      ...prev,
      [itemId]: newReview
    }))
    if (codeParam) {
      dispatchDetailTransaction(codeParam)
    }
  }

  const { loading, payload, error } = detailTransaction
  const trx = payload || null

  const formattedDate = trx?.created_at
    ? new Date(trx.created_at).toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
    : ''

  return (
    <>
      <div className="breadcrumb-halaman">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a onClick={handlePageHome} className="clickable">Beranda</a>
            </li>
            <li className="breadcrumb-item">
              <a onClick={handlePageHistory} className="clickable">Riwayat transaksi</a>
            </li>
            <li className="breadcrumb-item active">Detail pesanan</li>
          </ol>
        </nav>
      </div>

      <div className="container">
        <div className="cover-keranjang-all">
          <div className="cover-isi">
            <div className="cover-card-produk" style={{ width: '100%' }}>
              <div
                style={{
                  padding: '10px 10px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <button
                  onClick={handlePageHistory}
                  style={{
                    padding: '8px 20px',
                    background: '#F5152C',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    fontSize: '0.9em',
                    outline: 'none'
                  }}
                >
                  Kembali ke Riwayat
                </button>
                <h2 className="judul"></h2>
              </div>

              {loading ? (
                <div style={{ textAlign: 'center', padding: '40px 0', color: '#666' }}>
                  Memuat detail transaksi...
                </div>
              ) : error || !trx ? (
                <div style={{ textAlign: 'center', padding: '40px 0' }}>
                  <p style={{ color: '#888', marginBottom: '15px' }}>
                    {error?.message || 'Data transaksi tidak ditemukan.'}
                  </p>
                  <button
                    onClick={handlePageHistory}
                    style={{
                      padding: '8px 20px',
                      background: '#F5152C',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      fontSize: '0.9em'
                    }}
                  >
                    Kembali ke Riwayat
                  </button>
                </div>
              ) : (
                <div
                  style={{
                    backgroundColor: '#fff',
                    overflow: 'hidden',
                  }}
                >
                  {/* Header Info */}
                  <div
                    style={{
                      padding: '16px 20px',
                      borderBottom: '1px solid #eee',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      gap: '10px'
                    }}
                  >
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', marginBottom: '4px' }}>
                        <h3 style={{
                          margin: 0, fontSize: '1.1em', fontWeight: 'bold',
                          textTransform: 'uppercase'
                        }}>
                          Detail Pesanan: {trx.code}
                        </h3>
                        <StatusBadge status={trx.status} />
                      </div>
                      {formattedDate && (
                        <span style={{ fontSize: '0.85em', color: '#777', display: 'block' }}>
                          {formattedDate}
                        </span>
                      )}
                    </div>
                    <div>
                      <span style={{ fontSize: '0.9em', color: '#777' }}>
                        Total {trx.orders?.length || 0} Produk • <span style={{ fontSize: '1.1em', fontWeight: '800', color: '#fa591d' }}>{formatPrice(trx.total, 'Rp.')}</span>
                      </span>
                    </div>
                  </div>

                  {/* Orders List */}
                  <div style={{ padding: '20px' }}>
                    <h4 style={{ margin: '0 0 15px 0', fontSize: '1em', fontWeight: 'bold', color: '#333' }}>
                      Daftar Produk
                    </h4>
                    {trx.orders && trx.orders.length > 0 ? (
                      trx.orders.map((item, itemIdx) => {
                        const itemId = item.id || item.product_id || itemIdx
                        const itemReview = reviews[itemId] || item.review || null

                        return (
                          <div
                            key={itemId}
                            style={{
                              border: '1px solid #eee',
                              borderRadius: '6px',
                              padding: '12px 16px',
                              marginBottom: '10px',
                              background: '#fff'
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontSize: '0.9em'
                              }}
                            >
                              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                {item.product?.image && (
                                  <img
                                    src={process.env.REACT_APP_IMAGE_URL + item.product.image}
                                    alt={item.product?.name}
                                    style={{ width: '56px', height: '56px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ddd' }}
                                  />
                                )}
                                <div>
                                  <span style={{ fontWeight: '600', color: '#333', fontSize: '0.95em' }}>
                                    {item.product?.name || `Produk #${item.product_id}`}
                                  </span>
                                  <div style={{ color: '#777', fontSize: '0.88em', marginTop: '2px' }}>
                                    {item.quantity} x {formatPrice(item.price, 'Rp.')}
                                  </div>
                                </div>
                              </div>
                              <div style={{ fontWeight: 'bold', color: '#222', fontSize: '0.95em' }}>
                                {formatPrice(Number(item.price) * item.quantity, 'Rp.')}
                              </div>
                            </div>

                            {/* Section Review Button & Label */}
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #f0f0f0' }}>
                              {itemReview ? (
                                <div style={{ width: '100%', backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '6px', boxSizing: 'border-box' }}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                                    <span style={{ color: '#ffb400', fontSize: '1.2em' }}>
                                      {'★'.repeat(itemReview?.star ?? itemReview?.rating ?? 5)}{'☆'.repeat(5 - (itemReview?.star ?? itemReview?.rating ?? 5))}
                                    </span>
                                    <span style={{ fontSize: '0.85em', fontWeight: 'bold', color: '#555' }}>
                                      ({itemReview?.star ?? itemReview?.rating ?? 5}/5)
                                    </span>
                                  </div>
                                  <p style={{ margin: 0, fontSize: '0.88em', color: '#444', fontStyle: 'italic' }}>
                                    "{itemReview?.review ?? itemReview?.comment ?? ''}"
                                  </p>
                                </div>
                              ) : (
                                <>
                                  <span style={{ fontSize: '0.85em', color: '#888' }}>
                                    Belum Review ?
                                  </span>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setSelectedItem(item)
                                      setShowReviewModal(true)
                                    }}
                                    style={{
                                      padding: '4px 12px',
                                      fontSize: '0.82em',
                                      background: '#F5152C',
                                      color: '#fff',
                                      border: 'none',
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                      fontWeight: 'bold',
                                      outline: 'none'
                                    }}
                                  >
                                    Buat Review
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        )
                      })
                    ) : (
                      <p style={{ color: '#888', fontStyle: 'italic' }}>Tidak ada rincian produk.</p>
                    )}
                  </div>

                  {/* Voucher & Total Summary */}
                  {trx.voucher && (
                    <div style={{ padding: '0 20px 15px 20px' }}>
                      <div style={{ background: '#e8f5e9', padding: '10px 15px', borderRadius: '6px', border: '1px solid #c8e6c9', fontSize: '0.9em', color: '#2e7d32' }}>
                        Voucher Digunakan: <strong>{trx.voucher.code || trx.voucher.name}</strong>
                      </div>
                    </div>
                  )}

                  {/* Footer Actions */}
                  <div style={{ textAlign: 'right', padding: '15px 20px' }}>
                    <span style={{ fontSize: '0.85em', color: '#666', marginRight: '8px' }}>Total Pembayaran:</span>
                    <span style={{ fontSize: '1.2em', fontWeight: '800', color: '#fa591d' }}>{formatPrice(trx.total, 'Rp.')}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <FormReview
        show={showReviewModal}
        onClose={() => {
          setShowReviewModal(false)
          setSelectedItem(null)
        }}
        trx={trx}
        selectedItem={selectedItem}
        onSave={handleSaveReview}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    detailTransaction: {
      loading: state.transaction?.detailTransaction?.loading || false,
      payload: state.transaction?.detailTransaction?.payload || null,
      error: state.transaction?.detailTransaction?.error || null
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchDetailTransaction: (code) => dispatch(actionDetailTransaction(code))
  }
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(HistoryDetail)
